import styled, { css } from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Button from 'builder/components/Button'
import Media from 'builder/styles/media'
import Icon24 from 'builder/components/Icon'
import { rotation } from 'builder/styles/keyframes'
import { mainDesktopPadding } from '../../styles'

export const ContainerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S};

  height: 100%;

  ${Media.AboveTablet`
    width: 30%;
  `};
`

export const Container = styled.div<{ isEditActive: boolean }>(props => {
  return css`
    display: flex;
    width: 100%;
    flex-direction: column;
    border-radius: inherit;
    background-color: ${Colors.White};
    position: relative;
    overflow: auto;
    height: calc(100%);

    ${Media.AboveTablet`
      border-radius: ${Spacing['2XS']};
      gap: ${Spacing.M};
      justify-content: space-between;
      height: ${props.isEditActive ? `calc(100% - ${mainDesktopPadding})` : 'fit-content'};
    `};
  `
})

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px;
  width: 100%;
  justify-content: space-between;

  ${Media.AboveTablet`
    padding: ${Spacing.S};
    flex-direction: column;
    justify-content: unset;
    align-items: unset;
  `};
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 50px;
  justify-content: center;
`

export const Title = styled.div`
  color: ${Colors.Neutral90};
  font-weight: 19px;
  line-height: 22px;
  ${FontWeights.Medium};
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  ${Typography.S};
`

export const JobTitle = styled.div`
  color: ${Colors.Neutral50};
  ${Typography.Caption};
  ${FontWeights.Regular};
  margin-bottom: 12px;

  ${Media.Phone`
    margin-bottom: 0;
  `};
`

export const ScoreContainer = styled.div`
  display: flex;
  align-items: center;

  & path {
    stroke: ${Colors.Neutral50};
  }
`

export const ScoreLoading = styled.div`
  display: flex;
  background-color: ${Colors.Neutral5};
  border-radius: ${Spacing['2XS']};
  padding: ${Spacing['2XS']};

  gap: 6px;
`
export const ScoreItem = styled.div`
  display: flex;
  gap: 6px;
  padding: ${Spacing['2XS']};
  align-items: center;
  ${Typography.Tiny};
  ${FontWeights.Regular};
  color: ${Colors.Neutral90};
  background-color: ${Colors.Neutral5};
  border-radius: ${Spacing['2XS']};
`

export const ScoreValue = styled.div<{ score: number }>`
  ${Typography.Tiny};
  ${FontWeights.DemiBold};
  color: ${Colors.White};
  background: ${props =>
    props.score <= 30
      ? Colors.Red40
      : props.score > 30 && props.score <= 70
      ? Colors.Amber40
      : Colors.Green40};

  height: 20px;
  border-radius: 4px;
  padding: 1px 4px;
  align-items: center;
  justify-content: center;
  display: flex;
`

export const FinishEditButton = styled(Button)`
  display: flex;
  padding: ${Spacing.XS} ${Spacing.M};
  justify-content: center;
  align-items: center;
  border-radius: ${Spacing['3XS']};
  ${Typography.Body};
  ${FontWeights.Medium};
  margin: ${Spacing.S};
`

export const Spinner = styled(Icon24.Spinner)`
  animation: ${rotation} 0.5s infinite linear;
`

export const TabletButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S};
  padding: ${Spacing.S};
`
